var render = function render(){var _vm=this,_c=_vm._self._c;return _c('project-view-template',{attrs:{"hide-namespace":true,"namespace":_vm.namespace,"projectName":_vm.projectName,"asAdmin":_vm.asAdmin,"location":_vm.location,"show-settings":_vm.isProjectOwner,"hide-clone-button":!_vm.canCreateProject},on:{"open-clone-dialog":_vm.openCloneDialog}})
}
var staticRenderFns = []

export { render, staticRenderFns }